export const environment = {
  production: true,
  apiUrl: 'https://api.stratcare.co.uk',
  appID: 'stratcare_2-zpierhn',
  assessmentsCollection: 'assessments_staging',
  auth0Audience: 'https://mindlife-stratcare.uk.auth0.com/api/v2/',
  auth0ClientId: 'PlSQ7MgNB2yMqIDffwvFvOUSX82IE3EG',
  auth0Domain: 'mindlife-stratcare.uk.auth0.com',
  auth0RedirectUri:
    typeof window !== 'undefined'
      ? window.location.origin + '/callback'
      : 'https://stratcare-2-therapist-staging.web.app/callback',
  auth0Scope: 'openid profile email',
  baseUrl: 'https://stratcare-2-therapist-staging.web.app',
  consentRefusalCollection: 'consent_refusal_staging',
  databaseName: 'stratcare_2',
  deleteManyApiEndpoint:
    'https://eu-west-2.aws.data.mongodb-api.com/app/data-tpqlw/endpoint/data/v1/action/deleteMany',
  deleteOneApiEndpoint:
    'https://eu-west-2.aws.data.mongodb-api.com/app/data-tpqlw/endpoint/data/v1/action/deleteOne',
  ineligibleAssessmentCollection: 'ineligible_assessments_staging',
  postcodesCollection: 'postcodes',
  profilesCollection: 'profiles',
  responseLogCollection: 'response_log_staging',
  responseLogFunction: 'CREATE_RESPONSE_LOG_STAGING',
};
